export const MAX_DAYS_FOR_INACTIVE_STATUS = 30;
